module.exports = __webpack_public_path__ + "img/icon-settings-superficie.18d0ebf8.svg";